import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog, 
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Grid,
  Typography,
  Box
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import _ from "lodash";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import HotelApi from "Services/Hotel";

const HotelDelete = (props) => {
  const { openDialog, id, handleClose } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles();
  const dispatch = useDispatch();
  const [profileimage , setprofileimage]= useState(null);
  const [username , setusername]= useState(null);

  // Fetch Service Details

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        //console.log("fetched data passenger--->",res.data);
        setprofileimage(res.data.data[0].image);
        setusername(res.data.data[0].firstName);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    HotelApi.getHotelDetails(id).then(onSuccess, onFailure);
  }, [id]);
 
  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const handleDeleteHotel = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    let validatationPass = true;

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Hotels are deleted Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while deleting Hotel",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update service details api error", err);
    };

    if (validatationPass) {
      HotelApi.deleteHotel(id).then(onSuccess, onFailure);
    }
  };

  return (
    <>
     <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Are you sure delete this Hotel ?"}
        </DialogTitle>
        <DialogContent>
         
<Grid container spacing={2} rowSpacing={3} columnSpacing={4} className={classes.dialogbox}>
<Grid item xs={6} >
<div className={classes.lightText}>
<Typography variant="body2">{username}</Typography>
</div>
</Grid>
<Grid item xs={6} >
<div>
<Box
component="img"
sx={{
width: 50,
height: 50,
borderRadius: "25%",
objectFit: "cover",
boxShadow: 3,
}}
src={profileimage}
alt="Sample Image"
/>
</div>
</Grid>
</Grid> 

        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Disagree
          </Button>
          <Button onClick={handleDeleteHotel} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    </>
  );
};

export default HotelDelete;
